import { ReactNode, useRef } from 'react';

interface UseFilterBarParams {
  fixedFilters?: ReactNode;
  chips?: ReactNode;
  hasActiveSearch?: boolean;
  searchField?: ReactNode;
}

export const useFilterBar = ({
  fixedFilters,
  chips,
  hasActiveSearch,
  searchField,
}: UseFilterBarParams) => {
  const rootRef = useRef<HTMLDivElement>(null);

  const handleSurfaceClick = () => {
    if (!searchField) {
      return;
    }
    rootRef.current?.querySelector('input')?.focus();
  };

  const hasActiveValues = Boolean(chips) || Boolean(hasActiveSearch);
  const hasControls = Boolean(fixedFilters || chips);
  const hasSearchField = Boolean(searchField);

  return { rootRef, handleSurfaceClick, hasActiveValues, hasControls, hasSearchField };
};
